export default __webpack_public_path__ + "static/media/slider-left-hovered.e1c73884.png";